export class LockService {

  private static readonly DEFAULT_LOCK_MS: number = 1000;
  private readonly lockForMs: number = 0;
  private readonly beforeUnloadCall: () => void;
  private lastCallIndex: number = -1;
  private handler = null;

  public constructor(beforeUnloadCall: () => void, lockForMs?: number) {
    if (!lockForMs) {
      lockForMs = LockService.DEFAULT_LOCK_MS;
    }
    this.lockForMs = lockForMs;
    this.beforeUnloadCall = beforeUnloadCall;
  }

  /**
   * Check if a specific callIndex was the last one called by the lock service
   * @param callIndex the index to check against
   */
  public areOutstandingCalls(callIndex: number) {
    return this.lastCallIndex !== callIndex;
  }

  public lockAndRelease(call: (callIndex: number) => void) {
    if (this.handler != null) {
      this.clear();
    }
    window.onbeforeunload = this.beforeUnload.bind(this);
    this.handler = setTimeout(() => {
      this.clear();
      this.lastCallIndex++;
      call(this.lastCallIndex);
    }, this.lockForMs);
  }

  private clear() {
    clearTimeout(this.handler);
    window.onbeforeunload = null;
    this.handler = null;
  }

  private beforeUnload() {
    this.beforeUnloadCall();
    // firefox bug, where fetch throws an error in beforeunload, for an unknown reason
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    if (isFirefox) {
      return ''; // prompt from user, with this the fetch does not fail
    }
  }
}
